import { extend } from 'vee-validate';

extend('greaterThanOne', {
  validate: async (value) => value > 1,
  message: 'Počet voucherů musí být víc než 1!'
});

export default {};
